




















































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { VForm } from '@/interfaces';

@Component
export default class ManageDriversDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public formValid = false;

  public canCreateUser() {
    const ref: any = this.$refs.layout;
    if (ref && ref.rec) {
      console.log('canCreateUser', ref.rec.user_id, ref.rec.email, ref.rec.full_name);
      return ref.rec.email != null && ref.rec.full_name != null;
    }
    return false;
  }

  public async createUser(id: number) {
    const apiresult = await this.api.postActionAPIResult(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(id) + '/create_user');
    console.log('createUser', apiresult);
    if (apiresult && apiresult.id != null) {
      window.open('/manage/users/' + String(apiresult.id));
    }
  }

  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }

}
